import { motion } from "framer-motion";
import { fullAlbums, instrumentalAlbums } from "@/data/albums";
import { AlbumSection } from "@/components/AlbumSection";
import { Marquee } from "@/components/Marquee";

const SectionHeader = ({ index, kicker, title, sub }) => (
  <div data-testid={`wall-header-${kicker.toLowerCase()}`} className="px-6 md:px-12 pt-28 pb-4 max-w-[1500px] mx-auto w-full">
    <div className="flex items-end justify-between border-b border-white/10 pb-6">
      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.4em] text-[#8a8a8a] mb-4">{index}</p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-machine uppercase tracking-tight text-[#f2f0ec] text-5xl md:text-8xl leading-[0.85]"
        >
          {title}
        </motion.h2>
      </div>
      <p className="hidden md:block font-mono text-[10px] uppercase tracking-[0.25em] text-[#555] text-right max-w-[220px] leading-relaxed">{sub}</p>
    </div>
  </div>
);

export const AlbumWall = () => {
  return (
    <div id="discography" data-testid="album-wall">
      <SectionHeader
        index="I · Records"
        kicker="releases"
        title="Albums"
        sub="Two records where the voice leads. The one who got away, and the collective that came apart."
      />
      {fullAlbums.map((a, i) => (
        <AlbumSection key={a.id} album={a} index={i} number={i + 1} kind="Album" />
      ))}

      <Marquee />

      <SectionHeader
        index="II · Records"
        kicker="instrumentals"
        title="Instrumental Albums"
        sub="Twelve worlds built from harmony alone. No lyrics. The composition carries the story."
      />
      {instrumentalAlbums.map((a, i) => (
        <AlbumSection key={a.id} album={a} index={i + fullAlbums.length} number={i + 1} kind="Instrumental" />
      ))}
    </div>
  );
};
